import { GraphQLError } from '@affine/error';

import { ServerDeploymentType, ServerFeature } from './schema';

export function isGraphqlBackendDisabled() {
  return !!(globalThis as { __AFFINE_DISABLE_BACKEND__?: boolean })
    .__AFFINE_DISABLE_BACKEND__;
}

function localOrigin() {
  try {
    return globalThis.location?.origin ?? '';
  } catch {
    return '';
  }
}

function localServerConfig() {
  return {
    version: '0.27.0',
    baseUrl: localOrigin(),
    name: 'Local',
    features: [ServerFeature.LocalWorkspace],
    type: ServerDeploymentType.Affine,
    initialized: true,
    calendarProviders: [],
    credentialsRequirement: {
      password: {
        minLength: 8,
        maxLength: 32,
      },
    },
  };
}

/**
 * Resolve a GraphQL operation locally. Does not serialize or POST the document.
 * Only boot-time reads have data; everything else is rejected without network.
 */
export function resolveDisabledGraphql(operation: string): unknown {
  switch (operation) {
    case 'serverConfig':
      return { serverConfig: localServerConfig() };
    case 'oauthProviders':
      return { serverConfig: { oauthProviders: [] } };
    case 'getCurrentUser':
      return { currentUser: null };
    case 'getWorkspaces':
      return { workspaces: [] };
    default:
      throw new GraphQLError(
        'Backend disabled: GraphQL operations are not executed',
        {
          extensions: {
            status: 403,
            code: 'ACTION_FORBIDDEN',
            type: 'ACTION_FORBIDDEN',
            name: 'ACTION_FORBIDDEN',
            message: 'Backend disabled: GraphQL operations are not executed',
          },
        }
      );
  }
}
